import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import { Translate, LocalizeContextProps, withLocalize } from 'react-localize-redux';
import "./GalaxyGuidePage.less";
import { PageProps } from 'src/models/common/ComponentProps';

interface TrainingAndEducationGuideProps extends PageProps<{}>, LocalizeContextProps {
}

class TrainingAndEducationGuide extends React.Component<TrainingAndEducationGuideProps> {
    constructor(props: TrainingAndEducationGuideProps) {
        super(props);
        bindAllOfThis(this, TrainingAndEducationGuide.prototype);
    }

    private renderSections() {
        var sections = [];

        for (var i = 1; i <= 8; i++) {
            var body = (this.props.translate(`public.guide.trainingAndEducation.section${i}.body`) as string).split(" | ");
            var section = <div>
                <h3><Translate id={`public.guide.trainingAndEducation.section${i}.header`} /></h3>
                {body.map(para => <p>{para}</p>)}
            </div>;
            sections.push(section);
        }

        return sections;
    }

    render() {
        return <div className="galaxy-guide">
            <h2><Translate id="public.guide.trainingAndEducation.header" /></h2>
            <br></br>
            {this.renderSections()}
        </div>;
    }
}

export default withLocalize(TrainingAndEducationGuide);



// WEBPACK FOOTER //
// ./src/pages/public/TrainingAndEducationGuide.tsx